"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var memo = 0;

var generate = function generate() {
  memo++;
  return "temp-id-" + memo;
};

exports.generateTempId = generate;
var tempId = {
  generate: generate
};
exports.tempId = tempId;